/* istanbul ignore file */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useListContext } from 'framework/list';
import { DATE_FORMAT } from 'framework/utils';
import { Fade, Loading } from 'framework/ui/mui-builder';
import { Box, Typography } from '@mui/material';
import { performanceHeatmapSx } from '../performanceHeatmapStyles';

const PerformanceHeatmapLayout = ({
  filter,
  hasUpdateDate = true,
  children,
}: {
  filter: React.ReactNode;
  children: React.ReactNode;
  hasUpdateDate?: boolean;
}) => {
  const { data, filter: { period: { eq: currentMonth = '' } = {} } = {}, loading } = useListContext();
  const items = data?.items as any;
  const lastUpdated = items?.updatedAt ? moment(items.updatedAt).format(DATE_FORMAT.FULL) : '';
  const today = moment();
  const startOfMonth = moment(currentMonth).startOf('month');
  const endOfMonth = moment(currentMonth).endOf('month');
  const [mapLoading, setMapLoading] = useState(true);

  useEffect(() => {
    setMapLoading(true);
  }, [loading, currentMonth]);

  useEffect(() => {
    setMapLoading(false);
  }, [items]);

  if (loading || mapLoading) {
    return <Loading isInitialPosition />;
  }

  return (
    <Fade in={!loading && !mapLoading} timeout={20}>
      <Box sx={performanceHeatmapSx}>
        <Box className="performance-heatmap__header">
          <Box>
            <Typography component="div" variant="subtitle1">
              {startOfMonth.format(DATE_FORMAT.FULL_DATE)} -{' '}
              {today.month() === endOfMonth.month()
                ? today.format(DATE_FORMAT.FULL_DATE)
                : endOfMonth.format(DATE_FORMAT.FULL_DATE)}
            </Typography>
            {hasUpdateDate && <Typography component="div">Last indicators update: {lastUpdated}</Typography>}
          </Box>
          <Box className="performance-heatmap__header-controls">{filter}</Box>
        </Box>

        {children}
      </Box>
    </Fade>
  );
};

export default PerformanceHeatmapLayout;
